import React from 'react';
import { Phone, CheckCircle, Truck, Clock, FileText, Calendar, Wrench } from 'lucide-react';
export function FleetServicePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-5884">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-5885">
        <div className="container mx-auto px-4" data-id="element-5886">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-5887">
            FLEET MAINTENANCE PROGRAMS
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-5888">
            Preventative Maintenance That Saves Time and Money
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-5889">
        <div className="max-w-4xl mx-auto" data-id="element-5890">
          {/* The Problem */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5891">
            <p className="text-lg text-gray-700 mb-6" data-id="element-5892">
              <strong data-id="element-5893">
                Many truck and fleet owners ignore or postpone simple
                maintenance procedures because taking your trucks to service
                center eats up man-hours.
              </strong>{' '}
              Someone has to drop it off, someone has to pick that person up,
              and they both have to take more time to go back to retrieve the
              vehicle. You lose even more time and man-hours when you postpone
              or ignore scheduled maintenance schedules and end up with a
              breakdown on the side of the road for a problem that could have
              been prevented.
            </p>

            <div className="flex justify-center" data-id="element-5894">
              <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/RED%20FLEET.jpg?opt=w3" alt="Fleet maintenance trucks" className="max-w-full h-auto rounded-lg shadow-md" data-id="element-5895" />
            </div>
          </div>

          {/* Our Solution */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5896">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5897">
              Our Preventative Maintenance Solution
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-5898">
              <strong data-id="element-5899">Garrett Auto & Truck Repair</strong> believes in
              preventative maintenance. We'll help you save time and money by
              providing the diagnostic, repair and replacement services
              recommended by your vehicle manufacturer.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-5900">
              Here's how Garrett Auto & Truck can take the hassle out of
              scheduled maintenance:
            </h3>

            <div className="space-y-4 mb-8" data-id="element-5901">
              <div className="flex items-start bg-blue-50 rounded-lg p-4" data-id="element-5902">
                <FileText className="text-blue-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-5903" />
                <p className="text-gray-700" data-id="element-5904">
                  We maintain your service records and D.O.T. recordkeeping
                  requirements in our state-of-the-art database.
                </p>
              </div>

              <div className="flex items-start bg-green-50 rounded-lg p-4" data-id="element-5905">
                <Calendar className="text-green-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-5906" />
                <p className="text-gray-700" data-id="element-5907">
                  When it's time for service, we'll notify you.
                </p>
              </div>

              <div className="flex items-start bg-purple-50 rounded-lg p-4" data-id="element-5908">
                <Truck className="text-purple-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-5909" />
                <p className="text-gray-700" data-id="element-5910">
                  Convenient scheduling options to minimize downtime for your
                  fleet.
                </p>
              </div>

              <div className="flex items-start bg-yellow-50 rounded-lg p-4" data-id="element-5911">
                <Clock className="text-yellow-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-5912" />
                <p className="text-gray-700" data-id="element-5913">
                  We'll inform you of any safety or reliability concerns, so
                  that you'll know exactly how long the vehicle will be out of
                  service.
                </p>
              </div>

              <div className="flex items-start bg-green-50 rounded-lg p-4" data-id="element-5914">
                <CheckCircle className="text-green-600 mr-4 flex-shrink-0 mt-1" size={24} data-id="element-5915" />
                <p className="text-gray-700" data-id="element-5916">
                  Professional service to keep your fleet running reliably.
                </p>
              </div>
            </div>
          </div>

          {/* Services Offered */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5917">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center" data-id="element-5918">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-5919" />
              Fleet Maintenance Services
            </h2>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-5920">
              <div className="flex items-start" data-id="element-5921">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5922" />
                <span className="text-gray-700" data-id="element-5923">Oil & filter changes</span>
              </div>

              <div className="flex items-start" data-id="element-5924">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5925" />
                <span className="text-gray-700" data-id="element-5926">Chassis lubrication</span>
              </div>

              <div className="flex items-start" data-id="element-5927">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5928" />
                <span className="text-gray-700" data-id="element-5929">Transmission service</span>
              </div>

              <div className="flex items-start" data-id="element-5930">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5931" />
                <span className="text-gray-700" data-id="element-5932">Brake adjustments</span>
              </div>

              <div className="flex items-start" data-id="element-5933">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5934" />
                <span className="text-gray-700" data-id="element-5935">Alignment</span>
              </div>

              <div className="flex items-start" data-id="element-5936">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5937" />
                <span className="text-gray-700" data-id="element-5938">
                  Cooling System Maintenance
                </span>
              </div>

              <div className="flex items-start" data-id="element-5939">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5940" />
                <span className="text-gray-700" data-id="element-5941">
                  Fuel Injection Service – gas & diesel
                </span>
              </div>

              <div className="flex items-start" data-id="element-5942">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5943" />
                <span className="text-gray-700" data-id="element-5944">Belt & hose replacement</span>
              </div>

              <div className="flex items-start" data-id="element-5945">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5946" />
                <span className="text-gray-700" data-id="element-5947">Clutch adjustments</span>
              </div>

              <div className="flex items-start" data-id="element-5948">
                <CheckCircle className="text-green-600 mr-3 flex-shrink-0 mt-1" size={20} data-id="element-5949" />
                <span className="text-gray-700" data-id="element-5950">And much more</span>
              </div>
            </div>
          </div>

          {/* Benefits Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5951">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-5952">
              Why Choose Our Fleet Maintenance Program?
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-5953">
              <div className="text-center" data-id="element-5954">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5955">
                  <Clock className="text-blue-600" size={32} data-id="element-5956" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5957">
                  Save Time
                </h3>
                <p className="text-gray-700" data-id="element-5958">
                  Convenient scheduling means minimal disruption to your
                  operations
                </p>
              </div>

              <div className="text-center" data-id="element-5959">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5960">
                  <CheckCircle className="text-green-600" size={32} data-id="element-5961" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5962">
                  Prevent Breakdowns
                </h3>
                <p className="text-gray-700" data-id="element-5963">
                  Regular maintenance prevents costly roadside emergencies
                </p>
              </div>

              <div className="text-center" data-id="element-5964">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-5965">
                  <FileText className="text-purple-600" size={32} data-id="element-5966" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-5967">
                  Stay Compliant
                </h3>
                <p className="text-gray-700" data-id="element-5968">
                  D.O.T. recordkeeping and service tracking included
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-5969">
            <h2 className="text-3xl font-bold mb-4" data-id="element-5970">
              Start Your Fleet Maintenance Program Today
            </h2>
            <p className="text-xl mb-6" data-id="element-5971">
              Keep your fleet running smoothly with our comprehensive
              maintenance program
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-5972">
              <Phone className="mr-3" size={24} data-id="element-5973" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-5974">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}